import http from "@/utils/http";

export function NotificationApi(url, data, method) {
  let info = {
    url: "notification-service/" + url,
    method: method,
  };

  if (method === "GET") {
    info.params = data;
  } else {
    info.data = data;
  }

  return http(info);
}
